import * as React from 'react';
import CompanyListDataGrid from './CompanyListDataGrid';

function RankByIndustry({industry_group, data} :any) {
  let industryGroupTranslation = {
    automobiles: 'Automobiles & Components companies',
    banks: 'Banks',
    capital_goods: 'Capital Goods companies',
    consumer_durables: 'Consumer Durables & Apparel companies',
    commercial_services: 'Commercial & Professional Services companies',
    diversified_consumer_services: 'Diversified Consumer Services companies',
    diversified_financials: 'Diversified Financial Services companies',
    energy: 'Energy companies',
    food_beverages_tobacco: 'Food, Beverage & Tobacco companies',
    food_staples: 'Food Staples Retail companies',
    health_care_equipment: 'Health Care Equipment & Services companies',
    hotels_restaurants: 'Hotels, Restaurants & Leisure companies',
    household_personal_products: 'Household & Personal Products companies',
    insurance: 'Insurance companies',
    materials: 'Materials companies',
    media_and_entertainment: 'Media & Entertainment companies',
    pharmaceuticals_biotech: 'Pharmaceuticals, Biotechnology & Life Sciences companies',
    real_estate: 'Real Estate companies',
    retailing: 'Retailers',
    software_and_services: 'Software & Services companies',
    semiconductors: 'Semiconductors & Semiconductor Equipment companies',
    technology_hardware_equipment: 'Technology Hardware & Equipment companies',
    telecommunication_services: 'Telecommunication Services companies',
    transportation: 'Transportation companies',
    utilities: 'Utilities companies',
  }
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/industry_groups">All Industries</a></li>
            <li className="breadcrumb-item active" aria-current="page">{industryGroupTranslation[industry_group]}</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{industryGroupTranslation[industry_group]}</h4>
              <p className="card-description">
                <p>
                  Ordered by the highest ranked to the least. Only invest in companies with at least 10 years of financial history for more predictable returns. Remember to do your own research before investing in any company.
                </p>
              </p>
              <div>
                <CompanyListDataGrid
                  data={data}
                  showListing
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RankByIndustry;
